import {
  SET_REVIEWS,
  SET_SETTINGS,
  SET_SUBSCRIBES,
} from './settings.constants';


const initialState = {
  hourlyRate: 0,
  hourlyWithoutLicense: 0,
  hoursNumber: 0, //???
  clientsCount: 0,
  ordersCount: 0,
  ordersProgressCount: 0,
  clientsCountAll: 0,
  ordersCountAll: 0,
  ordersProgressCountAll: 0,
  reviews: [],
  subscribes: [],
};

const settingsReducer = (state = initialState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case SET_SETTINGS: {
      return {
        ...state,
        ...payload,
      };
    }

    case SET_SUBSCRIBES: {
      return {
        ...state,
        subscribes: payload,
      };
    }

    case SET_REVIEWS: {
      return {
        ...state,
        reviews: payload,
      };
    }

    default:
      return state;
  }
};

export default settingsReducer;
